import { Injectable } from '@angular/core';
import { ThreeService } from '../rendering/threejs/three.service';
import { Plane } from './primitives/floor-plane';
import { Store } from '@ngrx/store';
import { selectCameraTarget } from 'src/app/state/camera/camera.selector';

@Injectable({
  providedIn: 'root'
})
export class FloorPlaneService {

  plane: Plane

  constructor(
    private threeService: ThreeService,
    private store: Store
  ) {
  }

  async setup() {
    this.plane = new Plane(this.threeService)
    this.store.select(selectCameraTarget).subscribe((target) => {
      this.plane.updatePosition(target)
    })
  }
}
